import { configureStore } from '@reduxjs/toolkit';
import toolboxItemReducer from './ToolBoxItemSlice'

const toolBoxItemStore = configureStore({
  reducer: {
    toolboxItems: toolboxItemReducer
  }
});

export default toolBoxItemStore;